import { mapGetters } from 'vuex';
import {
    getConfigsRecConfig,
    getVisibleColumns,
    resolveColumnLabel,
    shouldShowColumn,
} from '../../../../../utils/configsRecConfig';

/**
 * Mixin compartido para las tablas de configsRec.
 * Proporciona acceso a la configuración de columnas del cliente.
 */
export default {
    computed: {
        ...mapGetters([
            "authentication_user",
        ]),
        configsRecConfig() {
            return getConfigsRecConfig(this.authentication_user);
        },
        visibleColumns() {
            return getVisibleColumns(
                this.configsRecConfig,
                this.tableConfigKey,
                this.authentication_user
            );
        },
        columnsMap() {
            const map = {};
            this.visibleColumns.forEach((column) => {
                map[column.key] = column;
            });
            return map;
        },
    },
    methods: {
        isColumnVisible(key) {
            return !!this.columnsMap[key];
        },
        getColumnLabel(key) {
            const column = this.columnsMap[key];
            if (!column) return key;
            return resolveColumnLabel(column, this.authentication_user, this.activeServiceId);
        },
        shouldShowColumn(column) {
            return shouldShowColumn(column, this.authentication_user);
        },
    },
};
